<div class="container-fluid">
  <app-pagetitle title="Locations" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="main-card-container">
    <div class="card">
      <div class="card-body">
        <!-- Header Section -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="card-title mb-0">Contracts</h4>
          
          <div class="d-flex align-items-center gap-2">
            <div class="dropdown" ngbDropdown *ngIf="!readonly">
              <button class="btn btn-light" ngbDropdownToggle>
                <i class="mdi mdi-dots-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a href="javascript:void(0);" class="dropdown-item">
                  <i class="mdi mdi-upload me-2"></i>Import Contract
                </a>
                <a href="javascript:void(0);" class="dropdown-item">
                  <i class="mdi mdi-download me-2"></i>Export Contract
                </a>
              </div>
            </div>
            <button class="btn btn-light" (click)="refresh()" ngbTooltip="Refresh">
              <i class="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="mb-4" *ngIf="!readonly">
          <button class="btn btn-primary w-100 w-sm-auto" (click)="onAddNew(addEditModal)">
            <i class="mdi mdi-plus-circle me-1"></i>Add New Contract
          </button>
        </div>

        <!-- Search Box -->
        <div class="search-box mb-4">
          <div class="position-relative">
            <input type="text" 
                   class="form-control" 
                   placeholder="Search contracts..."
                   [(ngModel)]="term" 
                   (ngModelChange)="onSearch()">
            <i class="mdi mdi-magnify search-icon"></i>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-responsive">
                <div>
            <button style="font-weight: 700;font-size: 1.3em;" (click)="decrementPage()" *ngIf="canDecrement()">&lt;</button>
            &nbsp; page {{pageNumber + 1}} of {{numberOfPages}} &nbsp;
            <button style="font-weight: 700;font-size: 1.3em;" (click)="incrementPage()" *ngIf="canIncrement()">&gt;</button>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="sticky-col">Contract Info</th>
                <th>Sales Rep</th>
                <th>Location</th>
                <th>Boards</th>
                <th>Sales Outlet</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredPagenatedLocations">
                <td class="sticky-col">
                  <div class="d-flex flex-column">
                    <span class="fw-medium">{{item.locationName}}</span>
                    <small class="text-muted">{{item.locationTag}}</small>
                  </div>
                </td>
                <td>
                  <span>{{item.salesRep?.firstName}} {{item.salesRep?.lastName}}</span>
                </td>
                <td>
                  <div class="d-flex flex-column">
                    <span>{{item.businessAddress.streetAddress1}}</span>
                    <small class="text-muted">
                      {{item.businessAddress.city}}, {{item.businessAddress.state}} {{item.businessAddress.zipCode}}
                    </small>
                  </div>
                </td>
                <td class="text-center">
                  <span class="badge bg-info">{{item.numBoards}}</span>
                </td>
    <td>
      <div class="form-check form-switch">
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="item.salesOutlet"
          [disabled]="readonly"
          id="salesoutlet-{{item.id}}"
          (change)="onToggleSalesOutlet(item, $event.target.checked)"
        />
      </div>
    </td>
                
                <td>
                
                  <div class="form-check form-switch">
                    <input type="checkbox" 
                           class="form-check-input" 
                           [checked]="item.enabled"
                           [disabled]="readonly"
                           id="enabled-{{item.id}}">
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-2">
                    <button *ngIf="canEdit(item)" class="btn btn-sm btn-light" (click)="onEdit(addEditModal, item)" ngbTooltip="Edit">
                      <i class="mdi mdi-pencil"></i>
                    </button>
                    <button *ngIf="canEdit(item)" class="btn btn-sm btn-light text-danger" (click)="onDelete(item.id)" ngbTooltip="Delete">
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                    <button *ngIf="canGenerateCollection(item)" class="btn btn-sm btn-primary" (click)="openCollectionModal(item)" ngbTooltip="Generate Collection">
                      <i class="mdi mdi-cash"></i>
                    </button>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="filteredLocation?.length === 0" class="text-center py-5">
            <p class="text-muted mb-0">No contracts found</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Modal -->
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{addEditMode}} Contract</h4>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    
    <div class="modal-body">
      <form [formGroup]="addEditFormGroup">
        <!-- Contract Info Section -->
        <div class="form-section mb-4">
          <h5 class="section-title">Contract Information</h5>
          
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Company Name</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="locationName" 
                     placeholder="Enter company name">
            </div>
            
            <!-- Location Start Date -->
            <div class="mb-3">
              <label for="locationStartDate" class="form-label">Start Date</label>
              <input
                id="locationStartDate"
                type="date"
                class="form-control"
                formControlName="locationStartDate"
              />
            </div>

            <!-- Location End Date -->
            <div class="mb-3">
              <label for="locationEndDate" class="form-label">End Date</label>
              <input
                id="locationEndDate"
                type="date"
                class="form-control"
                formControlName="locationEndDate"
              />
            </div>

            
            <div class="col-12">
              <label class="form-label">Sales Representative</label>
              <ng-select
                class="sales-rep-select"
                [items]="salesRepOptions"
                bindLabel="displayName"
                bindValue="id"
                formControlName="salesRep"
                placeholder="Type or select a sales rep"
                notFoundText="No sales representatives found"
                [searchable]="true"
                [clearable]="true"
                (change)="onChange()">
              </ng-select>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section mb-4" formGroupName="businessAddress">
          <h5 class="section-title">Business Address</h5>
          
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Street Address 1</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="streetAddress1" 
                     placeholder="Enter street address">
            </div>
            
            <div class="col-12">
              <label class="form-label">Street Address 2</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="streetAddress2" 
                     placeholder="Enter suite, unit, etc.">
            </div>
            
            <div class="col-12 col-md-6">
              <label class="form-label">City</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="city" 
                     placeholder="Enter city">
            </div>
            
            <div class="col-12 col-md-6">
              <label class="form-label">State</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="state" 
                     placeholder="Enter state">
            </div>
            
            <div class="col-12 col-md-6">
              <label class="form-label">ZIP Code</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="zipCode" 
                     placeholder="Enter ZIP code">
            </div>
            
            <div class="col-12 col-md-6">
              <label class="form-label">Country</label>
              <input type="text" 
                     class="form-control" 
                     formControlName="country" 
                     placeholder="Enter country">
            </div>
          </div>
        </div>

        <!-- Status Section -->
        <div class="form-section">
          <div class="form-check form-switch">
            <input type="checkbox" 
                   class="form-check-input" 
                   formControlName="enabled" 
                   id="enabled-input">
            <label class="form-check-label" for="enabled-input">Enable Contract</label>
          </div>
        </div>
      </form>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="modal.close('Save click')">Save Changes</button>
    </div>
  </ng-template>
</div>
